<template>
  <div>
    <section class="main-wrap ">
      <article class="main clearfloat">
        <div class="main-left hidden">
          <el-col>
            <el-menu
              :default-active="$route.path"
              unique-opened
              router
              class="el-menu-vertical-demo"
            >
              <el-submenu index="1">
                <template slot="title">
                  <i class="el-icon-location" />
                  <span>个人中心</span>
                </template>
                <el-menu-item index="/personal/user/news-notice">消息通知</el-menu-item>
                <el-menu-item index="/personal/user/my-collection">我的收藏</el-menu-item>
                <el-menu-item index="/personal/user/user-info">用户信息</el-menu-item>
                <el-menu-item index="/personal/user/qualifications-authen">资质认证</el-menu-item>
                <el-menu-item index="/personal/user/parss-modify">密码修改</el-menu-item>
                <el-menu-item index="/personal/user/feedback">意见反馈</el-menu-item>
              </el-submenu>

              <el-submenu v-login-show v-permission="['1-1','1-2', '1-3']" index="2">
                <template slot="title">
                  <i class="el-icon-location" />
                  <span>货源管理</span>
                </template>
                <el-menu-item index="/personal/goods/publish-goods">发布货源</el-menu-item>
                <el-menu-item index="/personal/goods/goods-list">货源列表</el-menu-item>
              </el-submenu>

              <el-submenu v-login-show v-permission="['2-1','2-2', '2-3']" index="3">
                <template slot="title">
                  <i class="el-icon-location" />
                  <span>运力管理</span>
                </template>
                <el-menu-item v-permission="['2-1','2-2']" index="/personal/transport/publish-transport">发布运力</el-menu-item>
                <el-menu-item index="/personal/transport/transport-list">运力列表</el-menu-item>
                <el-menu-item index="/personal/transport/invitated-list">被邀列表</el-menu-item>
                <el-menu-item index="/personal/transport/my-offer">我的报价</el-menu-item>
              </el-submenu>

              <el-submenu v-permission="['3-1','3-2', '3-3', '4-1','4-2', '4-3']" index="4">
                <template slot="title">
                  <i class="el-icon-location" />
                  <span>仓储管理</span>
                </template>
                <el-menu-item v-permission="['4-1','4-2']" index="/personal/store/publish-demand">发布仓储需求</el-menu-item>
                <el-menu-item v-permission="['3-1','3-2']" index="/personal/store/publish-supply">发布供给信息</el-menu-item>
                <el-menu-item v-permission="['4-1','4-2', '4-3']" index="/personal/store/store-demand-list">普仓需求列表</el-menu-item>
                <el-menu-item v-permission="['4-1','4-2', '4-3']" index="/personal/store/tank-demand-list">罐区需求列表</el-menu-item>
                <el-menu-item v-permission="['3-1','3-2', '3-3']" index="/personal/store/store-supply-list">普仓供给列表</el-menu-item>
                <el-menu-item v-permission="['3-1','3-2', '3-3']" index="/personal/store/tank-supply-list">罐区供给列表</el-menu-item>
                <el-menu-item v-permission="['3-1','3-2', '3-3']" index="/personal/store/my-invitation">我的邀请</el-menu-item>
                <el-menu-item v-permission="['4-1','4-2', '4-3']" index="/personal/store/cover-invitation">看仓邀请</el-menu-item>
                <el-menu-item v-permission="['3-1','3-2', '3-3']" index="/personal/store/cover-appointment">预约看仓</el-menu-item>
                <el-menu-item v-permission="['4-1','4-2', '4-3']" index="/personal/store/my-appointment">我的预约</el-menu-item>
              </el-submenu>

              <el-menu-item class="one" index="/personal/order-list">
                <template slot="title">
                  <i class="el-icon-location" />
                  <span>订单列表</span>
                </template>
              </el-menu-item>
              <el-submenu index="6">
                <template slot="title">
                  <i class="el-icon-location" />
                  <span>企业管理</span>
                </template>
                <!-- <el-menu-item index="/personal/enterprise/auch-admin">权限管理</el-menu-item> -->
                <el-menu-item index="/personal/enterprise/company-info">企业信息</el-menu-item>
                <el-menu-item index="/personal/enterprise/staff">员工管理</el-menu-item>
                <el-menu-item index="/personal/enterprise/sponsor">赞助列表</el-menu-item>
              </el-submenu>

              <el-submenu index="7">
                <template slot="title">
                  <i class="el-icon-location" />
                  <span>客户管理</span>
                </template>
                <el-menu-item index="/personal/customer/business-enterprise">业务公司</el-menu-item>
                <el-menu-item index="/personal/customer/contacts">联系人</el-menu-item>
              </el-submenu>
            </el-menu>
          </el-col>
        </div>
        <div class="main-right">
          <!--<keep-alive>-->
          <router-view />
          <!--</keep-alive>-->
        </div>
      </article>
    </section>
  </div>
</template>

<script>
export default {
  methods: {
    jump(name) {
      this.$router.push({ name })
    }
  }
}
</script>

<style scoped lang='scss'>
  .el-menu-item{
    padding-left: 51px!important;
  }
  .one.el-menu-item{
    padding-left: 20px!important;
  }
  .main-wrap{
    width: 100%;
    background: #F5F5F5;
    .main{
      width: 1200px;
      margin: 0 auto;
      padding-top: 85px;
      padding-bottom: 50px;
      .main-left{
        width: 250px;
        float: left;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        border: 1px solid #EDEDED;
      }
      .main-right{
        margin-left: 20px;
        width: 930px;
        height: auto;
        float: left;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        border: 1px solid #EDEDED;
      }
    }
  }
    
@media print {
  .hidden{
      display: none;
  }
}
</style>
